module.exports = __webpack_public_path__ + "static/media/landing-image.a3f36294.png";